import React, { useCallback, useContext, useEffect, useState } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Menu from "../components/Menu";
import { LoadingContext } from "../context/LoadingContext";
import ReactLoader from "../components/ReactLoader";
import { Modal, Button } from 'react-bootstrap';
import axios from "axios";
import Swal from "sweetalert2";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom.min";
const config = require("../config.json");

export default function Dash({ ipAddress, loginData }) {
  const [account] = useState(loginData?.address);
  const [loading, setLoading] = useContext(LoadingContext);
  const [mshow, setmshow] = useState(true);
  const [dash, setDash] = useState({});
  const history = useHistory();
  const modalClose = () => setmshow(false);
  const modalShow = () => setmshow(true);
  const handleDash = useCallback(async () => {
    setLoading(true);
    let data = JSON.stringify({
      ip: ipAddress,
      ulid: loginData.ulid,
    });
    let axiosConfig = {
      method: "post",
      url: `${config.baseUrl}desk`,
      headers: {
        ip: ipAddress,
        ulid: loginData.ulid,
        auth: loginData.auth,
        token: loginData.token,
        "Content-Type": "application/json",
      },
      data: data,
    };
    //console.log(axiosConfig)
    let response = await axios.request(axiosConfig);
    console.log(response.data);
    response = response.data;
    setLoading(false);
    if (response.status) {
      setDash(response);
    } else if (response.code === 30) {
      Swal.fire({
        icon: "info",
        title: "CaptiFx | Forex, Shares, CFDs & Commodities",
        text: response?.message,
      }).then(() => {
        history.push("/register");
      });
    }
  }, [
    history,
    ipAddress,
    loginData.auth,
    loginData.token,
    loginData.ulid,
    setLoading,
  ]);

  useEffect(() => {
    handleDash();
  }, [handleDash]);
  return (
    <>
      <div className="layout-container">
        <Menu />
        <div className="layout-page">
          <Header />
          {loading ? (
            <>
              <ReactLoader />
            </>
          ) : (
            <div className="content-wrapper mb-4">
              <div className="container-xxl flex-grow-1 container-p-y pt-2">
                <div className="row">
                  <div className="col-md-12  mb-2">
                    <div className="card h-100">
                      <div
                        className="card-header align-items-center"
                        style={{ padding: "4% 5% 5% 5%" }}
                      >
                        <div className="col-md-12">
                          <div className="row d-flex justify-content-between">
                            <div className="col-12 text-center">
                              <p className="card-text m-0 text-info  text-md">
                                <b>CaptiFx | Forex, Shares, CFDs & Commodities </b>
                              </p>
                              <div className='row d-flex justify-content-between'>
                                <div className='col-6 ' style={{ textAlignLast: "start" }}>
                                  <small className="text-sm">Dear : {dash?.info?.self?.name}</small>
                                </div>
                                <div className='col-6' style={{ textAlignLast: "end" }}>
                                  <small className="text-sm">Mobile :  {dash?.info?.self?.mobile}</small>
                                </div>
                              </div>
                              <div className='row d-flex justify-content-between'>
                                <div className='col-6 ' style={{ textAlignLast: "start" }}>
                                  <small className="text-sm">Email : {dash?.info?.self?.email}</small>
                                </div>
                                <div className='col-6' style={{ textAlignLast: "end" }}>
                                  <small className="text-sm"> Code :  {dash?.info?.sponsorId}</small>
                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                    <div className="card">
                      <div className="card-body dashinc">
                        <div className="d-flex justify-content-between">
                          <div className="card-info">
                            <p className="card-text m-0 text-sm">Total Invested</p>
                            <div className="d-flex align-items-end mb-2">
                              <small className="text-info ">
                                <i className='bx bxs-coin-stack'></i>{" "}
                                {dash?.info?.invested}
                              </small>
                            </div>
                          </div>
                          <div className="card-icon">
                            <span className="badge bg-label-info rounded p-2">
                              <i className="bx bx-coin-stack bx-sm"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                    <div className="card">
                      <div className="card-body dashinc">
                        <div className="d-flex justify-content-between">
                          <div className="card-info">
                            <p className="card-text m-0 text-white text-sm">
                              Payout
                            </p>
                            <div className="d-flex align-items-end mb-2">
                              <small className="text-info ">
                                <i className="bx bx-coin-stack bx-xs"></i>
                                {dash?.info?.payout}
                              </small>
                            </div>
                          </div>
                          <div className="card-icon">
                            <span className="badge bg-label-info rounded p-2">
                              <i className="bx bx-coin-stack bx-sm"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                    <div className="card">
                      <div className="card-body dashinc">
                        <div className="d-flex justify-content-between">
                          <div className="card-info">
                            <p className="card-text m-0 text-sm">
                              Paid Payout
                            </p>
                            <div className="d-flex align-items-end mb-2">
                              <small className="text-info ">
                                <i className="bx bx-coin-stack bx-xs"></i>{" "}
                                {dash?.info?.paid}
                              </small>
                            </div>
                          </div>
                          <div className="card-icon">
                            <span className="badge bg-label-info rounded p-2">
                              <i className="bx bx-coin-stack bx-sm"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-6 col-sm-6 mb-2">
                    <div className="card">
                      <div className="card-body dashinc">
                        <div className="d-flex justify-content-between">
                          <div className="card-info">
                            <p className="card-text m-0 text-sm">
                              Pending Payout
                            </p>
                            <div className="d-flex align-items-end mb-2">
                              <small className="text-info ">
                                <i className="bx bx-coin-stack bx-xs"></i>
                                {dash?.info?.pend}
                              </small>
                            </div>
                          </div>
                          <div className="card-icon">
                            <span className="badge bg-label-info rounded p-2">
                              <i className="bx bx-coin-stack bx-sm"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          )}
        </div>
      </div>
      <Modal show={mshow} onHide={modalClose}  >
        <Modal.Header closeButton  >
        </Modal.Header>
        <Modal.Body  >
          <img src={dash?.noti} alt="Promotional Image" width={'100%'} />
        </Modal.Body>
      </Modal>
    </>
  );
}
